module.exports = __webpack_public_path__ + "static/media/smWhiteLogo.ca61aedd.png";